import { render, staticRenderFns } from "./WallpaperDetail.vue?vue&type=template&id=451c4543&scoped=true&"
import script from "./WallpaperDetail.vue?vue&type=script&lang=js&"
export * from "./WallpaperDetail.vue?vue&type=script&lang=js&"
import style0 from "./WallpaperDetail.vue?vue&type=style&index=0&id=451c4543&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451c4543",
  null
  
)

export default component.exports